<template>
  <select class="col-sm-12">
    <slot></slot>
  </select>
</template>

<script>
import $ from "jquery"

export default {
  props: {
    options: {
      type: Array,
      default() {
        return []
      }
    },
    value: {
      type: [String, Number]
    },
    placeholder: {
      type: String,
      default: ''
    },
    defaultSelect: {
      type: Boolean
    },
    allowClear: {
      type: Boolean,
      default: true
    },
    disableEmpty: {
      type: Boolean
    },
    tags: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    var vm = this;
    $(this.$el).select2({
      theme: 'bootstrap',
      minimumResultsForSearch: -1,
      data: this.options,
      width: '100%',
      placeholder: this.getPlaceholder,
      tags: this.tags
    })
    .val(this.value)
    .trigger('change')
    .on('change', function () {
      vm.$emit('input', this.value);
    });
  },
  watch: {
    value(value) {
      $(this.$el).val(value).trigger('change');
    },
    options(options) {
      $(this.$el).empty().select2({
        data: options,
        placeholder: this.getPlaceholder,
        allowClear: this.isAllowClear,
        tags: this.tags
      });
      this.enabled();
    }
  },
  methods: {
    enabled() {
      if(this.options.length > 0 ) {
        $(this.$el).prop('disabled', false);
        this.selectedItem();
      } else {
        if(this.isDisableEmpty) {
          $(this.$el).prop('disabled', true);
        }
      }
    },
    selectedItem() {
      var selectedId = -1;
      if(this.hasDefaultSelected && this.options.length == 1) {
        selectedId = this.options[0].id
      }
      $(this.$el).val(selectedId).trigger('change');
    }
  },
  computed: {
    getPlaceholder() {
      return this.placeholder || '';
    },
    hasDefaultSelected() {
      return (this.defaultSelect == true);
    },
    isAllowClear() {
      return (this.allowClear == undefined || this.allowClear);
    },
    isDisableEmpty() {
      return (this.disableEmpty == true);
    }
  },
  destroyed() {
    $(this.$el).off().select2('destroy')
  }
};
</script>
